export const Budget = {

  edit: function() {
  }

}